import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import LinkButton from 'components/LinkButton'
import { CONTACT_ROUTE } from 'routes/constants'
import { sectionData } from './constants'

const InlineButtonHeader = ({
  buttonText,
  heading,
  hasButton,
  hasPaddingTop,
}) => (
  <div
    className={cx('sem__inline-button-header', {
      '--has-padding-top': hasPaddingTop,
    })}
  >
    <h2 className="sem__inline-button-header-heading">{heading}</h2>
    {hasButton && <LinkButton text={buttonText} route={CONTACT_ROUTE} />}
  </div>
)

InlineButtonHeader.defaultProps = sectionData

InlineButtonHeader.propTypes = {
  buttonText: PropTypes.string,
  heading: PropTypes.string,
  hasButton: PropTypes.bool,
  hasPaddingTop: PropTypes.bool,
}

export default InlineButtonHeader
